module.exports = __webpack_public_path__ + "img/sobha.f4c4162.webp";